import { render, staticRenderFns } from "./manage-agent.vue?vue&type=template&id=47ac3a25&scoped=true&"
import script from "./manage-agent.vue?vue&type=script&lang=js&"
export * from "./manage-agent.vue?vue&type=script&lang=js&"
import style0 from "./manage-agent.vue?vue&type=style&index=0&id=47ac3a25&prod&scoped=true&lang=css&"
import style1 from "./manage-agent.vue?vue&type=style&index=1&id=47ac3a25&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac3a25",
  null
  
)

export default component.exports